import { render, staticRenderFns } from "./PlayerHeader.vue?vue&type=template&id=290fde66&"
import script from "./PlayerHeader.vue?vue&type=script&lang=js&"
export * from "./PlayerHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports